// lib/modelist/references.ts
// What the 3D composer takes as a reference: photos, and the files an architect hands over. The runner keeps its own
// copy of this list (scripts/modelist/modelist-host.mjs), being plain ESM outside the app.
export const MODELIST_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp'] as const;
export const MODELIST_DESIGN_EXTENSIONS = ['pdf', 'dwg', 'dxf', 'ifc', 'skp', '3dm', 'rvt', 'obj', 'fbx', 'glb', 'gltf', 'stl', 'svg'] as const;
export const MODELIST_REFERENCE_MAX_BYTES = 100 * 1024 * 1024;
// A message's files travel base64 in one request to the runner, and V8 caps a string near 512 M characters: four
// files of 100 MB would not fit, three do.
export const MODELIST_REFERENCES_TOTAL_BYTES = 300 * 1024 * 1024;

/** The reference kind of a file name or asset path, by its extension (a DWG or a DXF comes with no reliable MIME type). */
export const modelistReferenceExtension = (name: string): string | null => {
  const ext = /\.([a-z0-9]+)$/i.exec(name.split(/[?#]/)[0] ?? '')?.[1]?.toLowerCase() ?? '';
  return (MODELIST_IMAGE_EXTENSIONS as readonly string[]).includes(ext) || (MODELIST_DESIGN_EXTENSIONS as readonly string[]).includes(ext) ? ext : null;
};
export const isModelistImageExtension = (ext: string) => (MODELIST_IMAGE_EXTENSIONS as readonly string[]).includes(ext);
